import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Emit } from 'vue-property-decorator';

var BreadcrumbHeader = /*#__PURE__*/function (_Vue) {
  _inherits(BreadcrumbHeader, _Vue);

  var _super = _createSuper(BreadcrumbHeader);

  function BreadcrumbHeader() {
    _classCallCheck(this, BreadcrumbHeader);

    return _super.apply(this, arguments);
  }

  _createClass(BreadcrumbHeader, [{
    key: "goBack",
    value: function goBack() {
      this.$router.go(-1);
    }
  }]);

  return BreadcrumbHeader;
}(Vue);

__decorate([Emit('back')], BreadcrumbHeader.prototype, "goBack", null);

BreadcrumbHeader = __decorate([Component], BreadcrumbHeader);
export default BreadcrumbHeader;